import React, {Component} from 'react';
import classnames from 'classnames';

import {IndexLink} from 'react-router';
import styles from './LinksBar.scss';

export default class LinksBar extends Component {
    render() {
        return (
            <div className={classnames(styles.wrapLinksBar, styles.hidLinksBar)}>
                <a className={styles.footerLink} href='https://app.cirrusmed.com/about-us'>{loc('about')}</a>
                <a
                    className={styles.footerLink}
                    href='https://app.cirrusmed.com/terms-and-conditions'
                  >
                    {loc('terms-and-conditions')}
                </a>
                <a className={styles.footerLink} href='https://cirrusmedicalnetwork.com/faq-2/'>{loc('FAQ')}</a>
                <a className={styles.footerLink} href='https://app.cirrusmed.com/contact-us'>{loc('contact-Us')}</a>
                <a
                    className={styles.footerLink}
                    href='https://app.cirrusmed.com/privacy-policy'
                >
                    {loc('privacy-policy-title')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://app.cirrusmed.com/membership-agreement'
                >
                    {loc('membership-agreement')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://app.cirrusmed.com/prescription-policy'
                >
                    {loc('prescription-policy-title')}
                </a>
                <a
                    className={styles.footerLink}
                    href='http://cirrusmedicalnetwork.com/blog/'
                    target='_blank'
                >
                    {loc('blog')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://cirrusmedicalnetwork.com/become-a-cirrus-medical-network-physician/'
                    target='_blank'
                >
                  {loc('become-a-cirrusmed-physician')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://cirrusmedicalnetwork.com/refund-policy/'
                    target='_blank'
                >
                    {loc('refund-policy')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://cirrusmedicalnetwork.com/partners/'
                    target='_blank'
                >
                    {loc('partners')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://cirrusmedicalnetwork.com/diagnostic-imaging-list/'
                    target='_blank'
                >
                    {loc('diagnostic-imaging-list')}
                </a>
                <a
                    className={styles.footerLink}
                    href='https://cirrusmedicalnetwork.com/sms-consent/'
                    target='_blank'
                >
                    {loc('sms-consent')}
                </a>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/LinksBar.js